import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { Slingo } from "@lib/titan2-slingo/dist/api/Slingo";
import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { SlingoController } from "@lib/titan2-slingo/dist/game/controller/SlingoController";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { GameReplayParser } from "../../api/replay/GameReplayParser";
import { ExtendedChooseCellResponseData } from "../model/response/data/ExtendedChooseCellResponseData";
import { ExtendedCollectResponseData } from "../model/response/data/ExtendedCollectResponseData";
import { ExtendedCurrentGameResponseData } from "../model/response/data/ExtendedCurrentGameResponseData";
import { ExtendedPurchaseEntryResponseData } from "../model/response/data/ExtendedPurchaseEntryResponseData";
import { ExtendedSpinResponseData } from "../model/response/data/ExtendedSpinResponseData";
import { ExtendedStakeToSpinResponseData } from "../model/response/data/ExtendedStakeToSpinResponseData";
import { GameEvent } from "./event/GameEvent";
import { GameTicketController } from "./GameTicketController";
import { GameWinController } from "./GameWinController";
/**
* GameController.ts
*/
export class GameController extends SlingoController {
    constructor(factory) {
        super(factory);
        this.skipNextTransition = false;
        Slingo.gameId = this.model.getGameId();
        Slingo.gameType = "fruttiboost";
        Slingo.requestsMap.getCurrentGame.dataClass = ExtendedCurrentGameResponseData;
        Slingo.requestsMap.purchaseEntry.dataClass = ExtendedPurchaseEntryResponseData;
        Slingo.requestsMap.spin.dataClass = ExtendedSpinResponseData;
        Slingo.requestsMap.chooseCell.dataClass = ExtendedChooseCellResponseData;
        Slingo.requestsMap.collect.dataClass = ExtendedCollectResponseData;
        Slingo.requestsMap.stakeToSpin.dataClass = ExtendedStakeToSpinResponseData;
        Service.setReplayParserClass(GameReplayParser);
        // @ts-ignore
        // so.Wrapper.getInstance()?.getModel()?.setEnginePathOverride?.(`slingo/${Slingo.gameType}`);
    }
    createWinController() {
        this.winController = new GameWinController(this.baseFactory);
    }
    createTicketController() {
        this.ticketController = new GameTicketController(this.baseFactory);
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(SlingoEvent.SLINGO_TICKET_ANIMATION_COMPLETE, this.handleSlingoTicketAnimationComplete);
        this.registerGame(SlingoEvent.SLINGO_WIN_ANIMATION_COMPLETE, this.handleSlingoWinAnimationComplete);
        this.registerGame(CommonGameEvent.REPLAY_START, this.handleReplayStart);
    }
    updateConfig(config) {
        super.updateConfig(config);
        this.model.setFeatureConfig(config.getFeatureConfig());
    }
    updateResponsibleGaming() {
        // Overridden because SlingoController explicitly doesn't update responsible gaming during replay, which breaks the number of purchase spins remaining.
        const progress = this.model.getGameProgress();
        if (progress) {
            const spinsRemaining = progress.getPurchasableSpinsRemaining();
            const spinsAvailable = progress.getPurchasableSpinsAvailable();
            this.responsibleGaming.update(spinsRemaining, spinsAvailable);
        }
    }
    updateSpinState() {
        if (Service.isReplay() && this.model.isPurchaseSpin()) {
            // In replay, automatically request a new spin after a delay.
            this.callAfter(1000, () => this.dispatchGame(CommonGameEvent.SPIN_REQUEST));
        }
        super.updateSpinState();
    }
    async updateGame() {
        if (!this.skipNextTransition && !this.model.isFirstGame() && this.model.isPurchaseEntry()) {
            await this.dispatchBlockingEvent(GameEvent.NEXT_GAME_TRANSITION);
        }
        if (!Service.isReplay() && !Service.isReplayStopping()) {
            this.skipNextTransition = false;
        }
        super.updateGame();
    }
    async handleSlingo() {
        await this.model.waitForTicketDabsInProgress();
        this.dispatchGame(SlingoEvent.SLINGO_TICKET_ANIMATION);
    }
    handleSlingoTicketAnimationComplete() {
        this.updateTotalWin();
        this.dispatchGame(SlingoEvent.SLINGO_WIN_ANIMATION);
    }
    handleSlingoWinAnimationComplete() {
        this.dispatchGame(SlingoEvent.SLINGO_PAY_TABLE);
    }
    handleReplayStart() {
        this.skipNextTransition = true;
    }
}
//# sourceMappingURL=GameController.js.map